// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ClINxztOIkf\\+rIehTuky0Q\\=\\={width:375px}", "",{"version":3,"sources":["webpack://./resources/js/v2/pages/equipment/models/listing/styles.module.scss"],"names":[],"mappings":"AAAA,6BACE,WACF","sourcesContent":[".categoryContainer {\n  width: 375px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"categoryContainer": "ClINxztOIkf+rIehTuky0Q=="
};
export default ___CSS_LOADER_EXPORT___;
